<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid"  @keyup.enter.native="getChgPkgEndTimeListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" @keyup.enter.native="getChgPkgEndTimeListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="getChgPkgEndTimeListHandler">搜索查询</el-button>
				<el-button type="success" plain icon="el-icon-s-ticket" @click="batchOptVisible = true">批量过期</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column type="index" label="序号" align="center"></el-table-column>      
            <el-table-column label="ICCID号" width="160" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号" width="160px" align="center"></el-table-column>
            <el-table-column prop="packageName" label="当前套餐" width="120px" align="center"></el-table-column>
            <el-table-column prop="oldTime" label="原过期时间" width="180px" align="center"></el-table-column>
            <el-table-column prop="newTime" label="新过期时间" width="180px" align="center"></el-table-column>
            <el-table-column prop="createTime" label="操作时间" width="180px" align="center"></el-table-column>
            <el-table-column prop="createOptName" label="操作人" width="120px" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        </el-table>            
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
		 
		 
		<el-dialog :append-to-body="true"  title="批量过期" :visible.sync="batchOptVisible" width="600px" @close="cancel" :close-on-click-modal="false">
		    <el-form ref="batchOptForm" :model="batchOptForm" label-width="100px">
		        <el-form-item label="导入Excel：" prop="uploadExcel">
		            <el-upload ref="upload" :action="uploadUrl('')" :headers="setHeader()" :limit="1" :auto-upload="false" :data="batchOptForm"  
					:on-change="handleChange" :on-success = 'handleSuccess'>
		                <el-button slot="trigger" plain>导入Excel</el-button>
		                <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
		            </el-upload>
		        </el-form-item>
		        <el-form-item label="操作类型：" prop="type">
		            <el-radio v-model="batchOptForm.type" label="0">过期全部</el-radio>
		            <el-radio v-model="batchOptForm.type" label="1">过期最新一个</el-radio>
		        </el-form-item>					 
				<el-form-item label="备注：" prop="remark">
					<el-input
					   type="textarea"
					   :rows="2"
					   maxlength="30"
					   placeholder="请输入内容"
					   show-word-limit
					   v-model="batchOptForm.remark">
					</el-input>
				</el-form-item>						 
		    </el-form>
			<p style="color: #f54646;">温馨提示：【过期全部】指过期SIM卡所有未过期套餐。【过期最新一个】指过期SIM卡最新添加的未过期套餐。</p>
		    <div slot="footer" class="dialog-footer">
		        <el-button @click="cancel">取 消</el-button>
		        <el-button type="primary" @click="batchEndTimeHandler()">确 定</el-button>
		    </div> 
		</el-dialog> 
		 
    </div>
</template>
<script>
import {getChgPkgEndTimeList} from '@/api/record.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: '',
                intoNo: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
			
			batchOptVisible: false,
			batchOptForm: {
				file: null,
			    type: '1',
				remark: null,
			},
        }
    },
    methods: {
        getChgPkgEndTimeListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getChgPkgEndTimeList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getChgPkgEndTimeListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getChgPkgEndTimeListHandler();
        },
		handleChange(file, fileList){
			this.batchOptForm.file = file.raw;
			
		    if(fileList.length > 0){
		        this.$refs.batchOptForm.fields[0].clearValidate();
		    }
		},
		handleSuccess(res){
		    if(res.code == 200){
		        this.batchOptVisible = false;
		        this.getChgPkgEndTimeListHandler();
		        this.$refs.upload.clearFiles();
		        this.$message.success(res.message);
		    }else{
		        this.$message.error(res.message);
		    }
		},
		cancel(){
		    this.batchOptVisible = false;
			this.$refs.upload.clearFiles();
		    this.$refs.batchOptForm.resetFields();
			this.batchOptForm.file = null;
		},

		batchEndTimeHandler(){
			let formData = new FormData();
			Object.keys(this.batchOptForm).forEach((key) => {
				formData.append(key, this.batchOptForm[key]);
			});
			common.sysRequest('sim/pkg/batchEndTime', formData, 'post').then(res => {
                if(res.data.code == 200){
					this.getChgPkgEndTimeListHandler();
					this.cancel();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            });
		},
    },
    created () {
        this.getChgPkgEndTimeListHandler();
    } 
}
</script>
<style lang="less" scoped>

</style>

